import { AssetOverview } from '../../features/asset-overview/asset-overview';
import { GraphData, isValidDate } from '@lp-ui-lib';
import { CurrentTelemetry } from '@lp-ui-lib';
import { TelemetryHistory } from '@lp-ui-lib';

export class GraphDisplay {
  public graphData!: GraphData[];
  public history!: TelemetryHistory;
  public loading!: boolean;
  public error!: boolean;
  public timeframe!: {
    start: Date;
    end: Date;
    custom: boolean;
  };
  public loadedTimeframe!: {
    start: Date;
    end: Date;
    custom: boolean;
  };
  public graphBrushActive = false;

  get Range(): Date[] {
    return this.timeframe ? [this.timeframe.start, this.timeframe.end] : [new Date(), new Date()];
  }

  set Range(range: Date[]) {
    if (
      range[0].toISOString() !== this.timeframe.start.toISOString() ||
      range[1].toISOString() !== this.timeframe.end.toISOString()
    ) {
      this.timeframe = {
        start: range[0],
        end: range[1],
        custom: true,
      };
    }
  }

  public currentTelemetry!: CurrentTelemetry;

  public setTimeframe(
    timeframe: { start: Date; end: Date; custom: boolean },
    component: AssetOverview
  ) {
    if (
      !timeframe ||
      !timeframe.start ||
      !timeframe.end ||
      !isValidDate(timeframe.start) ||
      !isValidDate(timeframe.end)
    )
      timeframe = { start: new Date(), end: new Date(), custom: false };

    this.timeframe = timeframe;
    let reloadData = false;
    if (!!this.graphData && !!this.graphData.find((data) => data.error)) reloadData = true;
    if (!this.loadedTimeframe) {
      this.loadedTimeframe = timeframe;
      reloadData = true;
    }
    if (timeframe.start < this.loadedTimeframe.start) {
      this.loadedTimeframe.start = timeframe.start;
      reloadData = true;
    }
    if (timeframe.end > this.loadedTimeframe.end) {
      this.loadedTimeframe.end = timeframe.end;
      reloadData = true;
    }
    if (reloadData) component.reloadTelemetry(this);
  }
}
